import * as React from 'react';
import Box from '@mui/material/Box';
import StarIcon from '@mui/icons-material/Star';
import Chip from '@mui/material/Chip';
import { createIntl } from 'react-intl';
import ar from './ar.json';
import en from './en.json';
import { LocaleContext } from '../../../contexts/language';
import PropTypes from 'prop-types';
const languages = {
  ar,
  en
};
export const FeaturedSection = ({ featured }) => {
  const localeConfig = React.useContext(LocaleContext);

  if (!featured) {
    return null;
  }
  const intl = createIntl({
    locale: localeConfig.lang,
    messages: languages[localeConfig?.lang] || languages.en
  });
  return (
    <Box
      sx={{ zIndex: 10, margin: '1rem' }}
    >
      <Chip
        color="primary"
        icon={<StarIcon />}
        label={intl.formatMessage({
          id: 'featuredChip.featured',
          defaultMessage: 'Featured'
        })}
      />
    </Box>
  );
};

FeaturedSection.propTypes = {
  featured:PropTypes.bool,
};
FeaturedSection.defaultProps={
  featured:false,
};

export default FeaturedSection;

